import LoginPage from "../views/Login/Login.jsx";
import RegisterPage from "../views/Register/Register.jsx"
import PasswordResetPage from "../views/PasswordReset/PasswordReset.jsx"
import HomePage from "../views/Home/Home.jsx"
import {UserIsNotAuthenticated} from "../utils/AuthRouter"
import { withRouter } from 'react-router-dom';


const publicRoutes=[
    {
        path: "/login",
        title:"Login",
        component: withRouter(UserIsNotAuthenticated(LoginPage))
    },
    {
      path:"/",
      title:"iSpani",
      component:HomePage
    },
    {
        path:"/register",
        title:"Create Account",
        component:RegisterPage
    },
    {
        path:"/passwordreset",
        title:"Password Rest",
        component:PasswordResetPage
    }
]

export default publicRoutes


// WEBPACK FOOTER //
// ./src/routes/public.jsx